import { DecimalPipe } from '@angular/common';
import { inject, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'valueFormatDecimals',
  pure: false
})
export class ValueFormatDecimalsPipe implements PipeTransform {

  constructor(
    private decimalPipe: DecimalPipe
  )
  {}

  transform (value: number, decimals: number = 2): string {
    let valueDivided = value;
    let suffix = '';

      if (value >= 10000000) {
        valueDivided = value / 1000000;
        suffix = 'M'
      } else if (value >= 100000) {
        valueDivided = value / 1000;
        suffix = "k";
      } else {
        valueDivided = value;
    }

    const formatted = this.decimalPipe.transform(valueDivided, `1.0-${decimals}`)
    return formatted + suffix
  }

}
